import { render, staticRenderFns } from "./tour-notification.vue?vue&type=template&id=9e43a0f6&"
import script from "./tour-notification.vue?vue&type=script&lang=js&"
export * from "./tour-notification.vue?vue&type=script&lang=js&"
import style0 from "./tour-notification.vue?vue&type=style&index=0&id=9e43a0f6&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projects\\git new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e43a0f6')) {
      api.createRecord('9e43a0f6', component.options)
    } else {
      api.reload('9e43a0f6', component.options)
    }
    module.hot.accept("./tour-notification.vue?vue&type=template&id=9e43a0f6&", function () {
      api.rerender('9e43a0f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/tour-notification.vue"
export default component.exports